import { Component, OnInit } from '@angular/core';
import {UtilityService} from '../../services/utility-service';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-print-view',
  templateUrl: './print-view.component.html',
  styleUrls: ['./print-view.component.scss']
})
export class PrintViewComponent implements OnInit {

  title: string;
  columns: any;
  data: any;
  date:any;
  userId:any;
  month:any;
  prevRoute:any;
  transmissionDetails:any[];
  constructor(private utilService: UtilityService, private location:Location, private router: Router, private activatedRoute: ActivatedRoute,
              private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    const printDataMap = this.utilService.getPrintViewData();
    this.title = printDataMap.get('title');
    this.columns = printDataMap.get('columns');
    this.data = printDataMap.get('data');

    //preserving the previous route results to avoid additional network call on cancel
    this.activatedRoute.queryParams.subscribe(params => {

      if (params.transmissionDetails !== undefined) {
        this.transmissionDetails = JSON.parse(atob(params.transmissionDetails));
        if (params.date !== undefined) {
          this.date = params.date;
        }
        if (params.userId !== undefined) {
          this.userId = params.userId;
        }
        if (params.month !== undefined) {
          this.month = params.month;
        }
        if (params.prevRoute !== undefined) {
          this.prevRoute = params.prevRoute;
        }
      }
      this.cdr.detectChanges();
    });
  }

  printPage() {
    window.print();
  }

  cancel() {
    console.log('Inside print page Cancel', this.prevRoute );
    if (this.prevRoute !== undefined &&  this.prevRoute === 'viewtransmission') {
      this.router.navigate(['viewtransmission'], {
        queryParams: {
          transmissionDetails: btoa(JSON.stringify(this.transmissionDetails)),
          date:this.date,
          userId:this.userId,
          month:this.month
        }
      });
    } else {
      this.location.back();
    }
    // this.router.navigate([".."]);
  }

}
